import React, { useState } from "react";
import { Send } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import BrandSelector from "@/components/BrandSelector";
import UserMenu from "@/components/UserMenu";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogDescription } from "@/components/ui/dialog";
import { DialogTitleWithBug } from "@/components/ui/dialog-title-with-bug";
import { SupportChatInterface } from "@/components/support/SupportChatInterface";
import { useSupportUnreadCount } from "@/hooks/useSupportUnreadCount";

export const MobileHeader: React.FC = () => {
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [selectedThreadId, setSelectedThreadId] = useState<string | undefined>();
  const unreadCount = useSupportUnreadCount();

  return (
    <>
      <div className="sticky top-0 z-40 flex items-center justify-between px-4 py-2 bg-background border-b">
        <SidebarTrigger className="ml-1" />
        <div className="flex-1 flex justify-center px-4">
          <BrandSelector />
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            onClick={() => setIsSupportOpen(true)}
          >
            <Send className="h-5 w-5" />
            {unreadCount > 0 && (
              <Badge
                variant="destructive"
                className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
              >
                {unreadCount}
              </Badge>
            )}
          </Button>
          <UserMenu />
        </div>
      </div>

      <Dialog open={isSupportOpen} onOpenChange={setIsSupportOpen}>
        <DialogContent className="max-w-2xl h-[500px] p-0 gap-0 overflow-hidden flex flex-col">
          <DialogTitleWithBug
            popupName="Support Chat"
            popupContext={window.location.pathname}
            isOpen={isSupportOpen}
            className="sr-only"
          >
            Support Chat
          </DialogTitleWithBug>
          <DialogDescription className="sr-only">Chat with support</DialogDescription>
          <div className="flex-1 min-h-0">
            <SupportChatInterface
              selectedThreadId={selectedThreadId}
              onSelectThread={setSelectedThreadId}
              onClose={() => setIsSupportOpen(false)}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};